// extracted by css-extract-rspack-plugin
export default {"state":"State-module__state--jOM1M","heading":"State-module__heading--OWSb9","head":"State-module__head--OWTWb","desktop-stores":"State-module__desktop-stores--qDTPd"};